import type { Ceviri } from "../tip";
import type { motor as tr } from "../tr/motor";
import { deger } from "./motor/deger";
import { olcu } from "./motor/olcu";
import { sanal } from "./motor/sanal";

/** English dictionary · engine messages. */
export const motor: Ceviri<typeof tr> = { ...deger, ...olcu, ...sanal };
